import axios from "axios";

export class SupplierWithdrawals {
    get(filters) {
        return axios.post(`/api/financials/withdrawals/supplier`, { filters })
    }
}
